import MinimalLayout from "layout/MinimalLayout";
import { lazy } from "react";
import Loadable from "ui-component/Loadable";
const VerifyPage = Loadable(lazy(() => import("views/pages/verify")));

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/verify",
      element: <VerifyPage />,
    },
  ],
};

export default AuthenticationRoutes;
